import React, { Component } from 'react'
import Header from './Header'
import Links from './Links'
import { extend } from '../../../utils/classes'

export class Footer extends Component {
  render() {
    const baseClass = 'footer'
    const containerClass = extend(baseClass, 'container')
    return (
      <footer className={baseClass}>
        <div className={containerClass}>
          <Header parentClass={containerClass} />
          <Links parentClass={containerClass} />
        </div>
      </footer>
    )
  }
}

export default Footer
